import { createArrayComparator, createNamedEqualityChecker } from '../../utils'

import type { CybusEndpoint, CybusMapping, CybusNode } from '..'

export enum CybusServiceDataResourceType {
    ENDPOINT = 'ENDPOINT',
    MAPPING = 'MAPPING',
    NODE = 'NODE',
}

export type CybusServiceDataResource = Readonly<{
    id: (CybusMapping | CybusEndpoint | CybusNode)['id']
    type: CybusServiceDataResourceType
    topics: readonly string[]
}>

export const areCybusServiceDataResourceEquals = createNamedEqualityChecker<CybusServiceDataResource>(
    { id: null, type: null, topics: createArrayComparator() },
    'areCybusServiceDataResourceEquals'
)
